module.exports = __webpack_public_path__ + "img/T4-B-rc_4.011534e8.png";